import Navbar from './components/Navbar';
import SkyBroadband from './pages/Broadband';
import Mobile from './pages/Mobile';
// import Hero from './components/Hero';
// import Highlights from './components/Highlights';
// import Model from './components/Model';
// import Features from './components/Features';
// import HowItWorks from './components/HowItWorks';
// import Footer from './components/Footer';

import Deals from './pages/Deals';
import SkyHomepage from './pages/SkyHomepage';
import Watch from './pages/Watch';
import { Route, Routes } from 'react-router-dom';

const App = () => {
  return (
    // <main className="bg-black">
    //   <Navbar />
    //   <Hero />
    //   <Highlights />
    //   <Model />
    //   <Features />
    //   <HowItWorks />
    //   <Footer />
    // </main>
    <>
<Navbar />
    <Routes>
      
      <Route path="/" element = {<SkyHomepage/>}/>
      <Route path="/watch" element = {<Watch/>}/>
      <Route path="/broadband" element = {<SkyBroadband/>}/>
      <Route path="/mobile" element = {<Mobile/>}/>
      <Route path="/deals" element = {<Deals/>}/>
      </Routes>
      </>
  )
}

export default App;
